import { fromJS } from 'immutable/dist/immutable';
import { basicSort } from '../../../../util/sortUtils';
import { refColumns, refSort } from '../../../InfoReduxConstant';

export const CLEAR_RUNUP_INFO = 'CLEAR_RUNUP_INFO';

export const GET_RUNUP_INFO_REFERENCES_REQUEST = 'GET_RUNUP_INFO_REFERENCES_REQUEST';
export const GET_RUNUP_INFO_REFERENCES_SUCCESS = 'GET_RUNUP_INFO_REFERENCES_SUCCESS';
export const GET_RUNUP_INFO_REFERENCES_FAILURE = 'GET_RUNUP_INFO_REFERENCES_FAILURE';

export const GET_RUNUP_INFO_REQUEST = 'GET_RUNUP_INFO_REQUEST';
export const GET_RUNUP_INFO_SUCCESS = 'GET_RUNUP_INFO_SUCCESS';
export const GET_RUNUP_INFO_FAILURE = 'GET_RUNUP_INFO_FAILURE';

export const RUNUP_INFO_REFERENCE_SORT = 'RUNUP_INFO_REFERENCE_SORT';
export const RUNUP_INFO_TOGGLE_COLUMN = 'RUNUP_INFO_TOGGLE_COLUMN';

const initialState = fromJS({
  fetchedRunup: false,
  runup: {},
  fetchedReferences: false,
  references: [],

  sort: refSort,
  visibleColumns: refColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const runupInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_RUNUP_INFO:
      return initialState;

    case RUNUP_INFO_REFERENCE_SORT:
      return state.merge(fromJS({
        references: basicSort(action.sort, state.get('references')),
        sort: action.sort,
      }));

    case GET_RUNUP_INFO_REFERENCES_REQUEST:
      return state.set('fetchedReferences', false);
    case GET_RUNUP_INFO_REFERENCES_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case GET_RUNUP_INFO_REFERENCES_FAILURE:
      return state.set('fetchedReferences', true);

    case GET_RUNUP_INFO_REQUEST:
      return state.set('fetchedRunup', false);
    case GET_RUNUP_INFO_SUCCESS:
      return state.merge(fromJS({
        fetchedRunup: true,
        runup: action.response,
      }));
    case GET_RUNUP_INFO_FAILURE:
      return state.set('fetchedRunup', true);

    case RUNUP_INFO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
